<div style="text-align:center;padding:5px;"
  *ngIf="lunchMealChoice != null && (angularMatDataMonthlyLunchMenu.data.length == 0 || !showMontlyLunchMenuGrid)" translate>
  No Monthly Lunch Menu data exists for this month
</div>
<div [hidden]="!showMontlyLunchMenuGrid">
  <mat-table #table [dataSource]="angularMatDataMonthlyLunchMenu" multiTemplateDataRows
    *ngIf="angularMatDataMonthlyLunchMenu != null && angularMatDataMonthlyLunchMenu.data.length > 0" aria-label="Monthly Lunch Menu Data Table" matSort
    matSortDisableClear matSortActive="Date" matSortDirection="desc" id="LMDataTable" style="min-width: 1300px;">
    <ng-container matColumnDef="Date">
      <mat-header-cell *matHeaderCellDef style="max-width:150px;min-width:150px;" mat-sort-header>
          <span translate>Date</span>
        <filter class="mat-filter" [clearFilterEvent]="clearFilterEvent" id="dateFilter"
          [data]="angularMatDataMonthlyLunchMenu" columnName="Date" dataType="date"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let LM" style="min-width:150px;max-width:150px;">
        <span style="width:33px;">{{LM.Date|date:'EEE'}}</span> {{LM.Date|date:'MM/dd/yy'}}
      </mat-cell>
    </ng-container>
    <ng-container *ngFor="let column of selectedChoice" [matColumnDef]="column.Choice">
      <mat-header-cell *matHeaderCellDef style="min-width:100px;align-items: flex-end"> {{'Choice' | translate}} {{getChoiceNumber(column.Choice)}}
      </mat-header-cell>
      <mat-cell *matCellDef="let LM" style="min-width:100px;">
        <span style="padding-right:5px;" *ngFor="let data of LM.MonthlyLunchMenuChoices |monthlyLunchMenuFilter:column">
          {{data.ChoiceDescription}}
        </span>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="columnsToDisplayLunchMenu;" id="MSdataHeader"
      style="position: sticky;top: 0;background: white;"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsToDisplayLunchMenu; let i = index;" id="MSdataRow{{i}}" matRipple
      [attr.aria-label]="getMonthlyLunchMenuAriaRow(row)" tabindex="0"></mat-row>
  </mat-table>
</div>
